// src/utils/printKOT.js — Kitchen Order Ticket (no prices). Shows customer name, groups identical items as "2x".
import { cleanAddons } from './addons';

const WIDTH = 32;
function center(str) { str = String(str); const space = Math.max(0, WIDTH - str.length); return ' '.repeat(Math.floor(space / 2)) + str; }
function line(ch = '-') { return ch.repeat(WIDTH); }
function wrap(text, max = WIDTH) {
  const words = String(text).split(' '); const out = []; let cur = '';
  words.forEach(w => {
    if ((cur + ' ' + w).trim().length > max) { if (cur) out.push(cur); cur = w; } else cur = (cur + ' ' + w).trim();
  });
  if (cur) out.push(cur);
  return out;
}
const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export function printKOT({ billNo, tableLabel, customerName, items = [], createdAt, isAddition = false }) {
  const now  = createdAt?.toDate?.() || new Date();
  const date = now.toLocaleDateString('en-IN', { day:'2-digit', month:'2-digit' });
  const time = now.toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit' });

  // group identical lines → one row with a quantity
  const groups = new Map();
  items.forEach(it => {
    const addons = cleanAddons(it.addons);
    const key = (it.name || 'Item') + '|' + addons.join(',');
    if (!groups.has(key)) groups.set(key, { name: it.name || 'Item', addons, qty: 0 });
    groups.get(key).qty += Number(it.qty) > 1 ? Number(it.qty) : 1;
  });
  const rows = [...groups.values()];
  const totalQty = rows.reduce((a, r) => a + r.qty, 0);

  const lines = [];
  const add = (s = '') => lines.push(s);

  add(center('*** KOT ***'));
  if (isAddition) add(center('** ADDITIONAL ITEMS **'));
  add(line('='));
  add(center('Bill: ' + billNo));
  add(center(tableLabel));
  if (customerName) wrap('Customer: ' + customerName).forEach(l => add(center(l)));
  add(center(date + '  ' + time));
  add(line('='));
  add('');

  rows.forEach(r => {
    wrap(r.qty > 1 ? `${r.qty}x ${r.name}` : r.name).forEach(l => add(l));
    r.addons.forEach(a => add('  + ' + a));
    add('');
  });

  add(line('='));
  add(center('Items: ' + totalQty));
  add('');

  const receiptText = esc(lines.join('\n'));
  const html = `
<!DOCTYPE html><html><head><meta charset="utf-8"><title>KOT ${esc(billNo)}</title>
<style>
  @page { margin: 0; size: 80mm auto; }
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family:'Courier New',monospace; font-size:14px; width:78mm; padding:2mm; }
  pre { font-family:'Courier New',monospace; font-size:14px; white-space:pre-wrap; word-break:break-word; line-height:1.4; font-weight:bold; }
</style></head><body>
<pre>${receiptText}</pre>
<script>window.onload=()=>{window.print();setTimeout(()=>window.close(),1000);}</script>
</body></html>`;

  const win = window.open('', '_blank', 'width=400,height=700,toolbar=no,menubar=no');
  if (!win) { alert('Please allow popups to print KOT'); return; }
  win.document.open(); win.document.write(html); win.document.close();
}